import AvatarIcon from '../../../assets/medium_default_optimized.png';
import PointIcon from '../../../assets/point-icon.svg';
import VerifiedIcon from '../../../assets/verified-icon.svg';
import FoundingCreatorIcon from '../../../assets/founding_creator_icon.png';
import { Link, useNavigate } from 'react-router-dom';
import { formatNumber } from '../../../utils/helper.util';

const UserCard = ({ user, avatarSize }) => {
  const navigate = useNavigate();

  function getDescription(text) {
    if (!text) return 'No description';
    if (text.length > 60) {
      return text.slice(0, 60) + '...';
    }
    return text;
  }

  return (
    <div>
      <div className="flex gap-3">
        <img
          className={`rounded-full ${avatarSize || 'w-[80px] h-[80px]'} flex-shrink-0 object-cover cursor-pointer`}
          src={user?.imgUrl || AvatarIcon}
          alt=""
          onClick={() => {
            navigate(`/${user?.username}`);
          }}
        />
        <div className="flex flex-col gap-2">
          <div
            className="flex items-center gap-1 cursor-pointer flex-wrap"
            onClick={() => {
              navigate(`/${user?.username}`);
            }}
          >
            <div className="font-[600] hover:text-growth-green transition duration-200">
              {user?.firstName}
            </div>
            {user?.isVerifiedAuthor && <img src={VerifiedIcon} className="w-6 h-6" alt="" />}
            {user?.isFoundingCreator && (
              <img
                src={FoundingCreatorIcon}
                className="w-6 h-6"
                alt="Founding Creator"
                title="Founding Creator"
              />
            )}
            {user?.username && (
              <span className="font-[600] text-sm text-02-dim-gray">@{user?.username}</span>
            )}
          </div>
          <div className="italic text-sm">{getDescription(user?.description)}</div>
          <div className="flex items-center gap-4">
            <p className="text-xs font-[800]">
              {formatNumber(user?.followerNumber)}
              <span className="font-[400] ml-2">
                {user?.followerNumber === 1 ? 'follower' : 'followers'}
              </span>
            </p>
            <p className="text-xs font-[800]">
              {formatNumber(user?.followingNumber)}
              <span className="font-[400] ml-2">following</span>
            </p>
            <p className="text-xs font-[800]">
              {formatNumber(user?.contributionNumber)}
              <span className="font-[400] ml-2">
                {user?.contributionNumber === 1 ? 'article' : 'articles'}
              </span>
            </p>
          </div>
          <div className="flex flex-wrap gap-1 md:gap-4">
            <div className="flex items-center space-x-1 text-xs text-growth-green-900 font-[800] whitespace-nowrap">
              <img className="w-4 h-4 md:w-5 md:h-5" src={PointIcon} alt="" />
              <span className="text-xs">
                {user?.receivedReputation?.totalPoints || 0} Earned Twigs
              </span>
              <span className="text-xs font-[400]">
                • {user?.receivedReputation?.totalUsers}{' '}
                {user?.receivedReputation?.totalUsers === 1 ? 'Reader' : 'Readers'}
              </span>
            </div>

            <div className="flex items-center space-x-1 text-growth-green-900 font-[800] whitespace-nowrap">
              <img className="w-4 h-4 md:w-5 md:h-5" src={PointIcon} alt="" />
              <span className="text-xs">{user?.sentReputation?.totalPoints || 0} Given Twigs</span>
              <span className="text-xs font-[400]">
                • {user?.sentReputation?.totalUsers}{' '}
                {user?.sentReputation?.totalUsers === 1 ? 'Writer' : 'Writers'}
              </span>
            </div>
          </div>
          <Link
            to={`/${user?.username}`}
            target="_blank"
            className="text-growth-green-500 font-[900] text-sm cursor-pointer w-fit"
          >
            View profile
          </Link>
        </div>
      </div>
      <div></div>
    </div>
  );
};

export default UserCard;
